import { useDarkTheme } from "src/hooks/useDarkTheme";

/** Shared by AuthHeader and BuilderHeader — identical in both, so extracted
 *  once rather than duplicated. */
export default function DarkThemeToggle() {
  const { isDarkTheme, toggleDarkTheme } = useDarkTheme();

  return (
    <li className="nav-item align-items-center me-2 dark-btn-li">
      <button type="button" className="btn btn-light btn-sm" aria-label={isDarkTheme ? "Switch to light theme" : "Switch to dark theme"}
        title={isDarkTheme ? "Switch to light theme" : "Switch to dark theme"}
        onClick={toggleDarkTheme}
      >
        <i className={`bi ${isDarkTheme ? "bi-sun" : "bi-moon-stars"}`} aria-hidden="true"/>
      </button>
    </li>
  );
}
